interface Props {
  estadoAsesoria: string;
}

const COPY = {
  titulo: 'Requiere correcciones',
  cuerpo:
    'El administrador rechazó uno o más elementos de esta asesoría. Corrige los datos señalados y vuelve a enviar a revisión. Si no estás de acuerdo, puedes responder al administrador.',
};

/** Banner fijo, presentacional, mostrado solo cuando la asesoría requiere correcciones. */
export function RequiereCorreccionesBanner({ estadoAsesoria }: Props) {
  if (estadoAsesoria !== 'REQUIERE_CORRECCIONES') return null;

  return (
    <div className="rounded-xl p-4 flex items-start gap-3 mb-4" style={{ background: '#fdf0ee', border: '1px solid #f5c6c0' }}>
      <div>
        <p className="text-[13px] font-semibold" style={{ color: '#c0392b' }}>
          {COPY.titulo}
        </p>
        <p className="text-[11px] mt-0.5" style={{ color: '#c0392b' }}>
          {COPY.cuerpo}
        </p>
      </div>
    </div>
  );
}
